import {
  AgentStatisticResponseInterface,
  StatisticsRepositoryInterface,
  StatisticsResponseInterface,
} from '@/services/QA/statistics/interfaces';
import { AxiosInstance } from 'axios';
import { CommentInterface, DossierCommentInterface } from '@/services/QA/comment/interfaces';

export default class StatisticsRepository implements StatisticsRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getMainStatistics(fromDate: string, toDate: string): Promise<StatisticsResponseInterface> {
    const res = await this.axios.get(`/qa-statistics/statistic?from=${fromDate}&to=${toDate}`);

    return res.data;
  }

  public async getAgentStatistic(
    id: string,
    fromDate?: string,
    toDate?: string,
  ): Promise<StatisticsResponseInterface> {
    const res = await this.axios.get(`/qa-statistics/statistic/agent/${id}?from=${fromDate}&to=${toDate}`);

    return res.data;
  }

  public async getAgentComments(userId: string): Promise<DossierCommentInterface[]> {
    const res = await this.axios.get(`/qa-controller/dossier/${userId}/comments`);

    return res.data;
  }

  public async createComment(userId: string, comment: Partial<CommentInterface>): Promise<DossierCommentInterface> {
    const res = await this.axios.post(`/qa-controller/dossier/${userId}/comments`, comment);

    return res.data;
  }
}
